import React, { useState } from 'react';
import { 
  BarChart2,
  ListFilter,
  Eye,
  EyeOff,
  Plus
} from 'lucide-react';
import { VisionDashboard } from '../components/vision/VisionDashboard';
import { ProductionList } from '../components/vision/ProductionList';
import { FinanceList } from '../components/vision/FinanceList';

// Componente de Botão
const Button = ({ 
  children, 
  onClick, 
  variant = 'primary',
  className = '' 
}: { 
  children: React.ReactNode; 
  onClick?: () => void; 
  variant?: 'primary' | 'secondary';
  className?: string;
}) => {
  const baseClasses = "h-[48px] px-6 rounded-xl font-everett text-[14px] transition-all flex items-center justify-center gap-2";
  const variants = {
    primary: "bg-white text-black hover:bg-[#F2F2F2]",
    secondary: "bg-white/[0.08] text-white hover:bg-white/[0.12]"
  };
  
  return (
    <button 
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};

const Vision = () => {
  const [view, setView] = useState<'analytics' | 'production' | 'finance'>('analytics');
  const [isBlurred, setIsBlurred] = useState(true);

  const handleToggleBlur = () => {
    setIsBlurred(!isBlurred);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold">Vision</h1>
              <p className="text-gray-400 mt-2">
                Gerencie seus projetos e acompanhe a produção
              </p>
            </div>
            <div className="flex gap-4">
              <Button
                variant="secondary"
                onClick={() => setView('analytics')}
                className={view === 'analytics' ? 'bg-white/[0.12]' : ''}
              >
                <BarChart2 size={20} />
                Dash
              </Button>
              <Button
                variant="secondary"
                onClick={() => setView('production')}
                className={view === 'production' ? 'bg-white/[0.12]' : ''}
              >
                <ListFilter size={20} />
                Produção
              </Button>
              <Button
                variant="secondary"
                onClick={() => setView('finance')}
                className={view === 'finance' ? 'bg-white/[0.12]' : ''}
              >
                Caixa
              </Button>
              <Button
                variant="secondary"
                onClick={handleToggleBlur}
                className="w-12"
              >
                {isBlurred ? <Eye size={20} /> : <EyeOff size={20} />}
              </Button>
            </div>
          </div>
        </div>

        {view === 'analytics' ? (
          <VisionDashboard
            isBlurred={isBlurred}
            onToggleBlur={handleToggleBlur}
          />
        ) : view === 'production' ? (
          <ProductionList
            isBlurred={isBlurred}
          />
        ) : (
          <FinanceList
            isBlurred={isBlurred}
          />
        )}
      </div>
    </div>
  );
};

export default Vision;
